import React, {useEffect, useState} from 'react';
import ArrowCircleUpIcon from '@material-ui/icons/ArrowUpward';
import './index.css';
import Grid from '@material-ui/core/Grid';

const ScrollArrow = () => {
  const [showScroll, setShowScroll] = useState(false);
  const scrollTop = () => window.scrollTo({top: 0, behavior: 'smooth'});
  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 200) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 200) {
      setShowScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop, true);
    return () => {
      window.removeEventListener('scroll', checkScrollTop, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.pageYOffset]);

  return (
    <Grid alignItems="center" container={true} direction="column" justifyContent="center">
      {showScroll ? <ArrowCircleUpIcon className="scrollTop" fontSize="large" onClick={scrollTop} /> : null}
    </Grid>
  );
};

export default ScrollArrow;
